import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Checkbox, FormControlLabel, FormGroup, Grid } from "@mui/material";
import { Box } from "@mui/system";

/**
//    * @component  Business Rule Checkbox  Component
//    * @description  Business Rule Checkbox for form component 
//    * @returns checkbox UI
//    */
function BusinessRuleCheckbox(props) {
  // helper props used here only; formik's name / onChange / onBlur stay on each label so the
  // checkbox values keep feeding the form's businessRule array
  const {
    businessRule,
    getRefBusinessRules,
    fieldType,
    fieldName,
    errors,
    touched,
    getFocus,
    modalClose,
    refName,
    ...labelProps
  } = props;
  const [businessRulesValues, setBusinessRuleValues] = useState([
    {
      displayName: "Fill",
      name: "Fill",
      value: false,
    },
    {
      displayName: "Bonus",
      name: "Bnus",
      value: false,
    },
    {
      displayName: "Paid",
      name: "Paid",
      value: false,
    },
  ]);

  const [check, setCheck] = useState(true); // flag to set Play everything

  useEffect(() => {
    let rules =
      props.businessRule && props.businessRule.length > 0
        ? props.businessRule
        : [];
    let count = 0;
    if (rules.length > 0) {
      const results = businessRulesValues.map((item, i) => {
        let obj = rules.some((val) => val === item.name);
        if (rules.length === 3) {
          setCheck(true);
        }
        if (obj) {
          item["value"] = true;
          count = count + 1;
        }
        return item;
      });
      setCheck(count === 3 || count === 0 ? true : false);
      setBusinessRuleValues(results);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //function on call change of business rule
  const handleChange = (e) => {
    let name = e.target.value;
    let val = e.target.checked;
    let rules = [];

    if (name === "Play Everything In SCH File") {
      rules = businessRulesValues.map((item, i) => {
        item.value = false;

        return item;
      });
    } else {
      rules = businessRulesValues.map((item, i) => {
        if (item.name === name) {
          item.value = val;
        }
        return item;
      });
    }
    setPlayEverything();
    setBusinessRuleValues(rules);
    props.getRefBusinessRules(rules);
  };

  // function to set checkbox option play every thing
  const setPlayEverything = () => {
    let count = 0;
    // eslint-disable-next-line array-callback-return
    businessRulesValues.map((a, i) => {
      if (a.value === true) {
        count = count + 1;
      }
    });

    setCheck(count === 3 || count === 0 ? true : false);
  };

  return (
    <div className="checkboxContainer">
      {/* E5 design: 15 px labels, purple ticks */}
      <Box
        sx={{
          "& .MuiFormControlLabel-label, & .playOnlyLabel": {
            fontSize: 12,
            fontFamily: "inherit",
            color: "#202020",
            textTransform: "none",
          },
          "& .MuiCheckbox-root.Mui-checked": { color: "#864797 !important" },
        }}
      >
        <FormGroup onChange={handleChange}>
          <Grid container spacing={{ xs: 1, md: 1 }}>
            <Grid item xs={4} sm={12} md={4}>
              <FormControlLabel
                name={props.fieldName}
                {...labelProps}
                control={<Checkbox checked={check} />}
                label={"Play Everything In SCH File"}
                value={"Play Everything In SCH File"}
                ref={props.refName}
              />
            </Grid>
            <Grid item xs={2} sm={2} md={2}>
              <FormControlLabel
                control={<span className="bulletPoint"></span>}
                label={<span className="playOnlyLabel">Play only</span>}
              />
            </Grid>
            {businessRulesValues.map((item, i) => {
              return (
                <Grid item xs={2} sm={2} md={2} key={i}>
                  <FormControlLabel
                    name={props.fieldName}
                    {...labelProps}
                    ref={props.refName}
                    control={
                      <Checkbox
                        key={i}
                        value={item.name}
                        checked={item.value}
                      />
                    }
                    label={item.displayName}
                  />
                </Grid>
              );
            })}
          </Grid>
        </FormGroup>
      </Box>
    </div>
  );
}

BusinessRuleCheckbox.propTypes = {
  businessRule: PropTypes.array,
};

export default BusinessRuleCheckbox;
